import { AnalyticsMetaKeys as key } from '../../../../../services/analytics/formatters/meta-keys'
import { IdentityEvent } from '../../../../../services/common/events/identity'
import { DOMEvents } from '../../../../../utils/dom'
import { AnalyticsEvent, IMParticleControlFields } from '../../../event'
import { GlobalDataFormatter } from '../../global-data'
import { PageEvents } from '../page-events'

const mParticleEvents: PageEvents = new PageEvents()

export class MParticleProvider extends AnalyticsEvent {

    private data: any
    private commonAttrs = [
        key.AD_BLOCKER,
        key.BRAND,
        key.BROWSER,
        key.BROWSER_LG,
        key.DEVICE_TYPE,
        key.DIVISION,
        key.DOMAIN,
        key.FEM_VERSION,
        key.TYPE,
        key.PAGE_URL,
        key.PLATFORM,
        key.PLATFORM_VERSION,
        key.USER_STATUS,
        key.VIEW_TYPE
    ]

    public constructor(data: any, type: string, value: string, action: string, element?: Element) {
        super(type, value, action, element)
        this.data = data
    }

    /**
     * Handle event
     */
    public handle(event?: Event): void {

        /**
         * Event Handler: updates the attributes list and sends it to mParticle
         * @var data will be different for each event
         *
         */

        let eventData: any = { ...this.data }  // extra data common to all providers

        const dataAttrs = this.getProviderAttributesList('mparticle', this.commonAttrs)
        // Get Data Values ( this.metaProperties this is data coming from page-data )
        const globalFormatter = new GlobalDataFormatter(this.metaProperties)
        dataAttrs.forEach((attr) => {
            try {
                const attrValue = globalFormatter.lookup(attr, event)
                if(attrValue !== '') {
                    eventData[attr] = attrValue
                }
            } catch(e) {
                console.error('GlobalDataFormatter error in class MparticleProvider', e)
            }
        })

        const customData = this.getProviderCustomData('mparticle')

        eventData = {
            ...eventData,
            ...customData
        }

        const mpControlFields: IMParticleControlFields = this.getProviderControlField('mparticle')

        const mpCustomFlags: any = {}
        if (mpControlFields.mp_custom_flags) {
            (mpControlFields.mp_custom_flags as any).forEach((flag: string) => {
                try {
                    const flagValue = globalFormatter.lookup(flag)
                    if(flagValue !== '') {
                        mpCustomFlags[flag] = flagValue
                    }
                } catch(e) {
                    console.error('MP Custom Flag error', e)
                }
            })
        }

        if(mpControlFields && mpControlFields.mp_native_event) {
            // check if mParticle supported native action include the current action
            if (PageEvents.mpSupportedNativeAction.includes(this.action)) {

                addEventListener(IdentityEvent.MP_READY, (e: any) => {
                    const mpSessionUuid = e.detail.mpSessionUuid ?
                        { [key.SESSION_UUID]: String(e.detail.mpSessionUuid) } : {}
                    const mpId = e.detail.mpId ? { [key.MP_ID]: String(e.detail.mpId) } : {}
                    const finalEventData = {...eventData, ...mpSessionUuid, ...mpId }
                    mParticleEvents.logPageView(
                        this.type || PageEvents.mpEventName.ScreenView,
                        finalEventData,
                        mpCustomFlags
                    )
                })
            } else {
                // Send error event to mParticle
                mParticleEvents.logCustomError('mParticleEvents not Supported', this.type)
                console.error('mParticleEvents not Supported', this.type, 'Action', this.action)
            }

        } else {
            // Send custom event to mParticle
            const mpEventType: string = mpControlFields.mp_event_type || 'Other'
            mParticleEvents.logEvent(
                this.type, // Change Event Name
                PageEvents.mpEventType[mpEventType],
                eventData,
                mpCustomFlags
                )
            // The before unload, click and signin events fire just before the page unloads
            if (
                this.action === DOMEvents.BEFORE_UNLOAD || this.action === DOMEvents.click
            ) {
                // Force upload of any event that was not uploaded yet, this fixes a bug on mobile where
                // click, scroll-depth and signin events are not sent to mParticle.
                // This bug was traced to the viafoura sdk which prevents mparticle handler from uploading events
                // that fire right before page is unloaded
                // mParticle team suggested calling window.mParticle.upload() right after we log the event
                mParticleEvents.upload()
            }
        }
    }
}
